import { cn } from '@/lib/cn';

type Tone = 'pass' | 'warn' | 'danger' | 'muted' | 'primary';

const TONES: Record<Tone, string> = {
  pass: 'bg-pass',
  warn: 'bg-warn',
  danger: 'bg-danger',
  muted: 'bg-muted',
  primary: 'bg-primary'
};

/** A 6px dot plus its label - the design's standard way of showing state in a table cell. */
export function StatusDot({ tone, label, className }: { tone: Tone; label?: string; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2 whitespace-nowrap', className)}>
      <span className={cn('size-1.5 shrink-0 rounded-full', TONES[tone])} />
      {label ? <span className="text-[13px] text-foreground">{label}</span> : null}
    </span>
  );
}
